import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { client } from '../lib/client';
import { landingPageQuery } from '../lib/queries.js';
import imageUrlBuilder from '@sanity/image-url';

const builder = imageUrlBuilder(client);

function urlFor(source) {
  return builder.image(source).url();
}

function LandingPage() {
  const navigate = useNavigate();
  const [homepageData, setHomepageData] = useState(null);

  useEffect(() => {
    client.fetch(landingPageQuery).then((data) => setHomepageData(data));
  }, []);

  if (!homepageData) return null;

  const handleClick = () => {
    navigate(homepageData.destinationPath || '/home');
  };

  const siteUrl = 'https://this-belongs-to.com';
  const ogImage = urlFor(homepageData.heroImage);

  const desktopImage = urlFor(homepageData.heroImage);
  const mobileImage = urlFor(homepageData.heroImageMobile);

  const desktopVideo = homepageData.heroVideoUrl || null;
  const mobileVideo = null;
  const useVideo = !!homepageData.useVideo && !!desktopVideo; // we need at least desktop video

  console.log(homepageData.heroVideoUrl);

  return (
    <>
      {/* SEO for root landing */}
      <Helmet>
        <title>This Belongs To </title>
        <meta
          name="description"
          content="This Belongs To - Designed and ethically manufactured in London."
        />
        <link rel="canonical" href={`${siteUrl}/`} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="This Belongs To" />
        <meta
          property="og:description"
          content="Underwear, swimwear and clothing - Designed and ethically manufactured in London."
        />
        <meta property="og:url" content={`${siteUrl}/`} />
        <meta property="og:image" content={ogImage} />
      </Helmet>

      <div
        className="relative w-full h-screen cursor-pointer overflow-hidden"
        onClick={handleClick}
      >
        {/* Background media */}
        {useVideo ? (
          <div className="absolute inset-0">
            {/* Mobile: video if provided, otherwise image */}
            {mobileVideo ? (
              <video
                className="block md:hidden w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
                poster={mobileImage || desktopImage}
              >
                <source src={mobileVideo} />
              </video>
            ) : (
              <div
                className="block md:hidden w-full h-full"
                style={{
                  backgroundImage: `url(${mobileImage || desktopImage})`,
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                }}
              />
            )}

            {/* Desktop: always video */}
            <video
              className="hidden md:block w-full h-full object-cover"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={desktopVideo} />
            </video>
          </div>
        ) : (
          // Fallback: image only (your original behaviour)
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${desktopImage})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
          >
            <style>
              {`
                @media (max-width: 768px) {
                  div[style] {
                    background-image: url(${mobileImage}) !important;
                  }
                }
              `}
            </style>
          </div>
        )}

        {/* COMMENTED OUT FOR NOW - MAY BRING BACK */}
        {/* Logo – 3/4 down on mobile, near bottom on desktop */}
        {/* <div
          className="
            absolute 
            z-10 
            left-1/2 
            -translate-x-1/2 
            top-[75vh]
            md:top-auto 
            md:bottom-12
          "
        >
          <img
            src={urlFor(homepageData.logoImage)}
            alt="This Belongs To Logo"
            className="h-12 md:h-19 w-auto"
          />
        </div> */}
      </div>
    </>
  );
}

export default LandingPage;
